const profile = {
    name: '이름',
    avatar: '아바타',
    givenName: '이름',
    familyName: '성',
    middleName: '중간 이름',
    fullname: '전체 이름',
    nickname: '별명',
    preferredUsername: '선호하는 사용자명',
    profile: '프로필',
    website: '웹사이트',
    gender: '성별',
    birthdate: '생년월일',
    zoneinfo: '시간대',
    locale: '로케일',
    address: {
        formatted: '주소',
        streetAddress: '도로명 주소',
        locality: '도시',
        region: '주/도',
        postalCode: '우편번호',
        country: '국가',
    },
    gender_options: {
        female: '여성',
        male: '남성',
        prefer_not_to_say: '답하지 않음',
    },
    checkbox_value: {
        checked: '예',
        unchecked: '아니오',
    },
};
export default Object.freeze(profile);
